import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-view-ch0',
    templateUrl: './view-ch0.component.html',
    styleUrls: [
        './view-ch0.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ViewCh0Component implements OnInit
{
    constructor() { }

    ngOnInit ()
    {
    }
}
